<template>
    <div class="complectations">
        <div class="complectations__container">
            <div class="complectations__title">Подберите комплектацию</div>
            <form class="complectations__form-filter">
                <select
                    v-model="select_model"
                    @change="selectModel"
                    class="complectations__select">
                    <option
                        v-for="model in models"
                        :key="model"
                    >{{ model }}</option>
                </select>
                <select
                    v-model="select_complectation"
                    @change="selectComplectation"
                    class="complectations__select">
                    <option
                        v-for="complectation in complectations"
                        :key="complectation"
                        >{{ complectation }}</option>
                </select>
                <select
                    @change="selectEngine"
                    v-model="select_engine"
                    class="complectations__select">
                    <option
                        v-for="engine in engines"
                        :key="engine"
                        >{{ engine }}</option>
                </select>
            </form>
            <table class="complectations__table">
                <thead>
                    <th>Модель</th>
                    <th>Комплектация</th>
                    <th>Двигатель</th>
                    <th></th>
                </thead>
                <tr
                    v-for="(item, index) in table_list_view"
                    :key="index">
                    <td class="complectations__table-row complectations__table-row--model">
                        <div
                            class="complectations__car-image" 
                            :class="{[`complectations__car-image--${item.model.split(' ').join('_').toLowerCase()}`]: true}"></div>
                    </td>
                    <td class="complectations__table-row complectations__table-row--complectation">{{ item.complectation }}</td>
                    <td class="complectations__table-row complectations__table-row--engine">{{ item.engine }}</td>
                    <td>
                        <div
                            class="btn-red complectations__btn"
                            @click="$emit('call-order', { title1: 'Узнать цену по акции' })"
                        >
                            Узнать цену по акции
                        </div>
                    </td>
                </tr>
            </table>
            <button
                v-if="is_show_btn_more"
                type="button"
                @click="showAll"
                class="complectations__btn--show_more">
                Показать ещё
            </button>
        </div>
	</div>
</template>

<script>
import ComplectationsInfo from "../common/complections-info";

export default {
    name: "block-complectation",
    data() {
        return {
            select_model: "Выберите модель",
            models: ["Выберите модель"],
            select_complectation: "Выберите комплектацию",
            complectations: ["Выберите комплектацию"],
            select_engine: "Выберите двигатель",
            engines: ["Выберите двигатель"],
            select_engine: "Выберите двигатель",
            table_list: [],
            table_list_view: [],
            is_show_btn_more: true,
        }
    },
    created() {
        const { COMPLECTATIONS } = ComplectationsInfo;
        const models = Array.from(new Set(COMPLECTATIONS.map(item => item.model)));

        this.models = ["Выберите модель", ...models];
        this.table_list = COMPLECTATIONS;
        this.table_list_view = this.table_list.slice(0, 3);
        this.is_show_btn_more = this.table_list.length === this.table_list_view ? false : true;
    },
    methods: {
        selectModel() {
            const { COMPLECTATIONS } = ComplectationsInfo;

            this.filterTableList("model");

            this.complectations = ["Выберите комплектацию", ...Array.from(
                    new Set(
                        COMPLECTATIONS
                        .filter(item => item.model === this.select_model)
                        .map(item => item.complectation)
                    )
                )
            ];

            this.select_complectation = "Выберите комплектацию";
        },
        selectComplectation() {
            const { COMPLECTATIONS } = ComplectationsInfo;

            this.filterTableList("complectation");

            this.engines = ["Выберите двигатель", ...Array.from(
                new Set(
                    COMPLECTATIONS
                    .filter(item => item.model === this.select_model && item.complectation === this.select_complectation)
                    .map(item => item.engine)
                )
            )];

            this.select_engine = "Выберите двигатель";
        },
        selectEngine() {
            const { COMPLECTATIONS } = ComplectationsInfo;
            
            this.filterTableList("engine");
        },
        filterTableList(type) {
            const { COMPLECTATIONS } = ComplectationsInfo;

            if (type === "model") {
                if (this.select_model === "Выберите модель") {
                    this.table_list = COMPLECTATIONS;
                } else {
                    this.table_list = COMPLECTATIONS.filter(item => item.model === this.select_model);
                }
            } else if (type === "complectation") {
                if (this.select_complectation === "Выберите комплектацию") {
                    this.table_list = COMPLECTATIONS.filter(item => item.model === this.select_model);
                } else {
                    this.table_list = COMPLECTATIONS.filter(item => item.model === this.select_model && item.complectation === this.select_complectation);
                }
            } else if (type === "engine") {
                if (this.select_engine === "Выберите двигатель") {
                    this.table_list = COMPLECTATIONS.filter(item => item.model === this.select_model && item.complectation === this.select_complectation);
                } else {
                    this.table_list = COMPLECTATIONS.filter(item => item.model === this.select_model && item.complectation === this.select_complectation && item.engine === this.select_engine);
                }
            }

            this.table_list_view = this.table_list.slice(0, 3);
            this.is_show_btn_more = this.table_list.length === this.table_list_view.length ? false : true;
        },
        showAll() {
            this.table_list_view = this.table_list;
            this.is_show_btn_more = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.complectations {
    background: #e3e5e6;
	padding: 50px 0;
	
	@media (max-width: 767px) {
		margin-top: 70px;
    }
    
    &__container {
        margin: 0px auto;
        max-width: 1140px;
        position: relative;
        padding: 0px 15px;
        text-align: center;
    }

    &__title {
        color: #686d71;
        font-size: 30px;
        font-weight: 700;
        text-transform: uppercase;
        border-left: 7px solid #ed0000;
        padding: 20px 0 20px 30px;
        margin-bottom: 30px;
    }

    &__form-filter {
        display: flex;
        justify-content: center;

        @media (max-width: 767px) {
            display: block;
        }
    }

    &__select {
        display: block;
        width: 24%;
        padding-left: 15px;
        margin-right: 5px;

        @media (max-width: 767px) {
            width: 100%;
            margin-bottom: 5px;
        }

        &:last-child {
            margin-right: 0;
        }
    }

    &__table {
        width: 100%;
        column-width: 25%;

        thead {
            @media (max-width: 767px) {
                display: none;
            }
        }

        tr {
            @media (max-width: 767px) {
                display: block;
            }
        }

        th {
            width: 25%;
            padding: 20px 20px 20px 0;

            font-size: 25px;
            font-weight: 500;
            text-align: left;
            color: #686d71;
        }

        td {
            text-align: left;

            @media (max-width: 767px) {
                display: block;
            }
        }

        td:last-child {
            text-align: right;
        }

        &-row {
            padding: 5px 0;

            &::before {
                display: none;
                font-weight: 700;

                @media (max-width: 767px) {
                    display: block;
                }
            }

            &--model::before {
                content: "Модель";
            }

            &--complectation::before {
                content: "Комплектация";
            }

            &--engine::before {
                content: "Двигатель";
            }
        }
    }

    &__btn {
        display: inline-flex;
        width: 100%;

        &--show_more {
            width: 270px;
            height: 40px;

            font-size: 16px;

            background: none;
            border: 1px solid black;

            @media (max-width: 767px) {
                margin-top: 30px;
            }
        }
    }

    &__car-image {
        width: 220px;
        height: 100px;
        background-repeat: no-repeat;
        background-size: 219px 98px;

        @each $car in 'outlander', 'asx', 'l200', 'eclipse_cross', 'pajero_sport', 'обновленный_asx', 'pajero' {
            &--#{$car} {
                background-image: url("../img/compl/#{$car}.png");
            }
        }
    }
}
</style>